// Singleton modal event bus with simple pub-sub
class ModalManager {
  static #instance;
  #subscribers = new Set();
  #state = { open: false, content: null, props: {} };

  static getInstance() {
    if (!ModalManager.#instance) ModalManager.#instance = new ModalManager();
    return ModalManager.#instance;
  }

  open(content, props = {}) {
    this.#state = { open: true, content, props };
    this.#emit();
  }

  close() {
    this.#state = { open: false, content: null, props: {} };
    this.#emit();
  }

  subscribe(fn) { this.#subscribers.add(fn); fn(this.#state); return () => this.#subscribers.delete(fn); }
  #emit() { this.#subscribers.forEach(fn => fn(this.#state)); }
}

export default ModalManager.getInstance();
